/*
==============================================================================
NUPEP Cart Framework
Version: 7.0.0

Cart Events

Author:
NUPEP Framework

Responsibilities
----------------
✓ Bind UI events
✓ Delegate cart actions
✓ Never talks directly to Shopify
✓ Never renders the cart
==============================================================================
*/

"use strict";

window.NUPEP = window.NUPEP || {};

NUPEP.CartEvents = {
  /*
    --------------------------------------------------------------------------
    Bind All Events
    --------------------------------------------------------------------------
    */

  bind() {
    /*
  this.subscriptionButtons();
  */
    this.quantityButtons();

    this.removeButtons();

    this.upsellButtons();
  },

  /*
    --------------------------------------------------------------------------
    Subscription Buttons
    --------------------------------------------------------------------------
    */

  subscriptionButtons() {
    document.querySelectorAll(".update-subscription").forEach((button) => {
      button.onclick = async () => {
        if (button.disabled) return;

        button.disabled = true;

        try {
          await NUPEP.Cart.replaceSubscription(button);
        } catch (error) {
          console.error(error);
        } finally {
          button.disabled = false;
        }
      };
    });
  },

  /*
    --------------------------------------------------------------------------
    Quantity Buttons
    --------------------------------------------------------------------------
    */

  quantityButtons() {
    document.querySelectorAll(".qty-plus").forEach((button) => {
      button.onclick = async () => {
        const key = button.dataset.key;

        const input = document.querySelector(`.qty-input[data-key="${key}"]`);

        if (!input) return;

        const quantity = Number(input.value) + 1;

        await NUPEP.Cart.change(key, quantity);
      };
    });

    document.querySelectorAll(".qty-minus").forEach((button) => {
      button.onclick = async () => {
        const key = button.dataset.key;

        const input = document.querySelector(`.qty-input[data-key="${key}"]`);

        if (!input) return;

        const quantity = Math.max(1, Number(input.value) - 1);

        await NUPEP.Cart.change(key, quantity);
      };
    });
  },

  /*
    --------------------------------------------------------------------------
    Remove Buttons
    --------------------------------------------------------------------------
    */

  removeButtons() {
    document.querySelectorAll(".lux-remove").forEach((button) => {
      button.onclick = async () => {
        if (!confirm("Remove this item from your cart?")) {
          return;
        }

        await NUPEP.Cart.remove(button.dataset.key);
      };
    });
  },

  /*
    --------------------------------------------------------------------------
    Upsell Products
    --------------------------------------------------------------------------
    */

  upsellButtons() {
    document.querySelectorAll(".lux-add").forEach((button) => {
      button.onclick = async () => {
        await NUPEP.Cart.add(
          Number(button.dataset.id),

          1,
        );
      };
    });
  },
};
